// Benutzerhandbuch der Kassa - INHALT, nicht nur Inhaltsverzeichnis.
//
// NEU GESCHRIEBEN am 26.8.2026 (Nutzer-Auftrag). Vorher zeigte der
// Hilfe-Bildschirm 47 eingescannte Seiten eines Fremd-PDFs von 2006. Das
// hatte drei Probleme, die sich durch Loeschen nicht beheben liessen:
//   - es beschrieb einen Funkscanner, den es nicht mehr gibt,
//   - auf jeder Seite standen Fremdlogo und Fremdmarke,
//   - und der Inhalt stimmte an mindestens acht Stellen nicht mehr mit
//     dieser Kassa überein (die Testsuite hatte sie einzeln nachgewiesen).
//
// QUELLE DIESER FASSUNG ist nicht das alte PDF, sondern der gepruefte
// Ist-Zustand: die Tastenbeschriftungen stammen aus lib/language/de/,
// die Abläufe aus den 96 Testfaellen in tests/cases.js. Wo das alte
// Handbuch etwas anderes behauptete, steht hier das, was die Kassa TUT.
//
// Aufbau: jedes Kapitel hat nr, titel, tiefe und (bei Blattkapiteln) text.
// text ist HTML - erlaubt sind <p>, <ul>/<li>, <b>, <br>.

export const HANDBUCH_UNTERTITEL = 'Stand 21.9.2026 - beschreibt diese Kassa';

// schritte: nummerierte Anleitung mit Bild. Die Bilder erzeugt
// tests/handbuch-bilder.js aus der ECHTEN Kassa - nach einer Aenderung an der
// Oberflaeche einfach neu laufen lassen, dann stimmen sie wieder.
const K = (nr, titel, tiefe, text, schritte) => ({ nr, titel, tiefe, text, schritte });

export const HANDBUCH_KAPITEL = [
K('1', 'Grundlegendes', 1),
K('1.1', 'Bildschirm und Bedienung', 2,
`<p>Die Kassa wird über den Bildschirm bedient. Alle Eingaben erfolgen mit
dem Finger oder mit einem angeschlossenen Handscanner.</p>
<p>Der Bildschirm gliedert sich in vier Bereiche:</p>
<ul>
<li><b>Links</b> die Funktionstasten (Sonderfunktionen, Preisinformation,
Nachrichten, Strauß/Topf/Geschenk, Bankomat-Funktionen, Inventur und
Retourware, Kunde erfassen, Kassenladen-Funktionen, Benutzerfunktionen,
Kassa Übergabe, Kassa abschließen, Abmelden).</li>
<li><b>Mitte oben</b> die Bonliste mit den erfassten Positionen, darunter
die Summenzeile.</li>
<li><b>Mitte unten</b> das Universaleingabefeld und der Zahlenblock.</li>
<li><b>Rechts</b> die Positions- und Bonfunktionen, die Zahlungsarten und
die Produkttasten.</li>
</ul>
<p>Oben laufen die Info-Symbole (siehe Kapitel 5), ganz oben links die
Tasten <b>Handbuch</b>, <b>Kalibrieren</b> und <b>Pflanze erkennen</b>.</p>`, [
  { text: "So sieht der Hauptbildschirm nach dem Anmelden aus.", bild: "anmelden-2-hauptschirm" },
  { text: "Links die Funktionstasten. Ganz unten steht das Logo des Geschäfts – eine Ziertafel ohne Funktion.", bild: "linke-leiste" },
]),
K('1.2', 'Universaleingabefeld', 2,
`<p>Das breite Feld unter der Bonliste nimmt jede Zahleneingabe auf: Mengen,
Preise, Beträge, Kunden- und Bonnummern. Was die Zahl bedeutet, entscheidet
die Taste, die Sie danach drücken.</p>
<p><b>Beispiel:</b> <i>5</i> eingeben und <b>Menge ändern</b> drücken setzt
die gewählte Position auf 5 Stück. Dieselbe <i>5</i> und <b>Preis ändern</b>
setzt stattdessen den Preis auf 5,00 EUR.</p>
<p>Die Taste <b>C</b> löscht das Feld, der Doppelpfeil löscht das letzte
Zeichen.</p>`),
K('1.3', 'Bonliste', 2,
`<p>Jede boniertere Position steht als eigene Zeile: Menge, Bezeichnung,
Einzelpreis und Zeilensumme. Die zuletzt erfasste oder angetippte Zeile ist
farbig hervorgehoben - <b>alle Positionsfunktionen wirken auf genau diese
Zeile</b>.</p>
<p>Wird die Liste länger als das Fenster, rutscht sie oben hinaus; die
neueste Zeile bleibt immer sichtbar. Unmittelbar unter der letzten Zeile
steht der Summenblock mit Netto, Mehrwertsteuer und Brutto, darunter die
grüne Summenzeile mit dem Bonwert.</p>`, [
  { text: "Mehrere Positionen auf einem Bon. Die zuletzt gewählte Zeile ist farbig hervorgehoben.", bild: "bonieren-3-mehrere-positionen" },
]),
K('2', 'Anmelden', 1),
K('2.1', 'Mit Personalnummer und PIN', 2,
`<p>Nach dem Start zeigt die Kassa den Anmeldebildschirm. Geben Sie Ihre
Personalnummer ein, dann Ihre PIN, und bestätigen Sie mit <b>OK</b>.</p>
<p>Die beiden Felder nehmen keine Tastatureingabe an - benutzen Sie den
Zahlenblock auf dem Bildschirm.</p>`, [
  { text: "Der Anmeldebildschirm: Personalnummer eintippen, dann PIN, dann OK.", bild: "anmelden-1-schirm" },
  { text: "Nach dem Anmelden erscheint der Hauptbildschirm.", bild: "anmelden-2-hauptschirm" },
]),
K('2.2', 'Mit Personalkarte', 2,
`<p>Statt der Eingabe können Sie Ihre Personalkarte scannen. Die
Personalnummer wird dann automatisch übernommen.</p>
<p>Fehlt Ihnen das Recht dazu, bricht die Kassa den Vorgang ohne Meldung ab.</p>`),
K('2.3', 'Mehrere Benutzer gleichzeitig', 2,
`<p>An einer Kassa können mehrere Benutzer gleichzeitig angemeldet sein -
in der Praxis bis zu sechs.</p>
<p>Beim Wechsel wird der offene Bon des bisherigen Benutzers <b>geparkt</b>.
Der neue Benutzer sieht seinen eigenen, leeren Bildschirm und kann normal
kassieren. Kehrt der erste Benutzer zurück, holt er seinen geparkten Bon
zurück und schliesst ihn ab. Bonnummern und Datenbankeinträge bleiben dabei
sauber getrennt.</p>`),
K('3', 'Bonieren und Bezahlen', 1),
K('3.1', 'Produkt erfassen', 2,
`<p>Es gibt drei Wege:</p>
<ul>
<li><b>Produkttaste</b> rechts antippen.</li>
<li><b>Handscanner</b>: den EAN-Code des Produkts scannen.</li>
<li><b>EAN-Code</b> eingeben: Nummer ins Universaleingabefeld tippen und die
Taste <b>EAN-Code</b> drücken.</li>
</ul>
<p>Ist ein Code unbekannt, meldet die Kassa das und boniert nichts.</p>`, [
  { text: "Produkttaste rechts antippen – oder den EAN-Code scannen.", bild: "bonieren-1-produkttasten" },
  { text: "Die Position steht sofort in der Bonliste, darunter die Summe.", bild: "bonieren-2-eine-position" },
]),
K('3.2', 'Menge bestimmen', 2,
`<p>Menge ins Universaleingabefeld eingeben, <b>dann</b> die Produkttaste
drücken. Nachträglich ändern Sie die Menge über
<b>Menge ändern</b> (Kapitel 3.3).</p>`),
K('3.3', 'Positionsfunktionen', 2,
`<p>Alle wirken auf die hervorgehobene Zeile. Tippen Sie die gewünschte
Zeile an, bevor Sie eine dieser Tasten drücken.</p>
<ul>
<li><b>Gewählte Position stornieren</b> - streicht die Zeile. Sie bleibt
durchgestrichen sichtbar und zählt nicht mehr zur Summe.</li>
<li><b>Menge ändern</b> - neue Menge eingeben, Taste drücken. Die Kassa
storniert dabei die alte Zeile und legt eine neue an; im Bon sehen Sie
beides.</li>
<li><b>Preis ändern</b> - neuen Einzelpreis eingeben, Taste drücken.</li>
<li><b>Absoluter Rabatt</b> - Betrag eingeben, Taste drücken. Der Betrag
wird von der Position abgezogen.</li>
<li><b>50% Abverkauf</b> - halbiert den Preis der Position. Die Zeile zeigt
danach zusätzlich den Rabatt.</li>
<li><b>EAN-Code</b> - siehe Kapitel 3.1.</li>
</ul>`, [
  { text: "Die Positionsfunktionen stehen rechts oben.", bild: "position-1-tasten" },
  { text: "Nach „Gewählte Position stornieren“: die Zeile bleibt durchgestrichen stehen und zählt nicht mehr zur Summe.", bild: "position-2-storniert" },
  { text: "Nach „50% Abverkauf“: die Zeile zeigt zusätzlich den Rabatt, die Summe sinkt.", bild: "position-3-rabatt" },
]),
K('3.4', 'Bonfunktionen', 2,
`<ul>
<li><b>Bonstorno</b> - verwirft den gesamten Bon.</li>
<li><b>Bon parken</b> - legt den Bon beiseite; er kann später
zurückgeholt werden. Wird auch beim Benutzerwechsel automatisch
ausgelöst.</li>
<li><b>Anzahlung</b> - nimmt eine Teilzahlung auf einen späteren Bon
entgegen.</li>
<li><b>Rechnungs/Bonkopien</b> - druckt eine Kopie eines früheren Belegs.</li>
<li><b>Reklamieren</b> - nimmt Ware zurück. Die in dieser Kassa
eingestellte Obergrenze beträgt <b>50 EUR</b>.</li>
<li><b>Gesamtrabatt (%)</b> - <b>diese Funktion ist abgeschaltet.</b> Die
Taste meldet "Diese Funktion ist nicht mehr verfügbar!" und bewirkt
nichts.</li>
</ul>`),
K('3.5', 'Bezahlen', 2,
`<p>Rechts unten stehen die Zahlungsarten:</p>
<ul>
<li><b>Bar</b> - Kundengeld eingeben; die Kassa zeigt das Retourgeld und
öffnet die Lade. Für gängige Scheine gibt es eigene Tasten.</li>
<li><b>Gutschein</b> - Gutscheinwert wird angerechnet.</li>
<li><b>Bankomat-terminal</b> und <b>Kreditkarte</b> - die Zahlung läuft
über das angeschlossene Terminal. Ist keines angeschlossen, zeigt die Kassa
einen Hinweis und einen Knopf <b>Bon drucken</b>.</li>
<li><b>Personalkauf</b> - Einkauf auf die eigene Personalnummer.</li>
<li><b>Zahlung Zentrale</b> und <b>Lieferschein</b> - für Rechnungs- und
Lieferfälle.</li>
<li><b>Wertkarte</b> - siehe Kapitel 3.6.</li>
</ul>
<p>Bleibt bei einer Kartenzahlung ein Restbetrag offen, schliesst der Bon
trotzdem normal ab.</p>`, [
  { text: "Die Zahlungsarten stehen rechts unten.", bild: "bezahlen-1-tasten" },
  { text: "Nach „Bar“ fragt die Kassa das Kundengeld ab.", bild: "bezahlen-2-bar" },
  { text: "Kundengeld eingeben – die Kassa zeigt Gegeben, Retour und Offen.", bild: "bezahlen-3-kundengeld" },
]),
K('3.6', 'Wertkarte', 2,
`<p>Wertkarten werden über die Kartennummer angesprochen. Es gibt zwei
Funktionen:</p>
<ul>
<li><b>Aufladen</b> - Betrag eingeben, die Karte wird um diesen Betrag
aufgewertet.</li>
<li><b>Bezahlen</b> - der Bonbetrag wird vom Kartenguthaben abgezogen.</li>
</ul>
<p>Das aktuelle Guthaben wird angezeigt. Zum Aufladen gibt es Tasten für
gängige Scheinwerte.</p>`, [
  { text: "Der Wertkarten-Schirm mit Guthaben, Scheintasten und den Tasten Aufladen und Bezahlen.", bild: "wertkarte-1-schirm" },
]),
K('3.7', 'Strauß, Topf und Geschenk', 2,
`<p>Ueber <b>Strauß Topf Geschenk</b> binden Sie mehrere bonierte Positionen
zu einem Artikel zusammen.</p>
<ul>
<li><b>Strauß</b> - fasst die Positionen zu einem Strauß zusammen. Bei
einem Geschenkstrauß kommt automatisch eine Zeile "Floristen Beiwerk"
dazu.</li>
<li><b>Biedermeierstrauß</b> und <b>Geschenktopf</b> - wie oben, mit
eigener Bezeichnung.</li>
</ul>
<p>Die Kassa fragt vor dem Binden nach. Liegt die Summe nahe an einem
eingestellten Schwellenpreis, kommt zusätzlich die Rückfrage, ob Sie noch
etwas ändern wollen. Eine <b>manuelle Preiseingabe gibt es nicht</b> - der
Preis ergibt sich aus den bonierten Positionen.</p>`, [
  { text: "Nach „Strauß Topf Geschenk“ erscheint die Auswahl.", bild: "strauss-1-auswahl" },
]),
K('3.8', 'Kunde erfassen', 2,
`<p>Mit <b>Kunde erfassen</b> ordnen Sie den Bon einem Kunden zu, entweder
durch Scannen der Kundenkarte oder über die Suche nach Name, Kartennummer
oder Postleitzahl.</p>
<p>Ist ein Kunde erfasst, blinkt oben rechts das Kundensymbol, und
kundengebundene Rabatte werden automatisch berücksichtigt.</p>`),
K('3.9', 'Preisinformation', 2,
`<p><b>Preisinformation</b> zeigt Preis und Lagerstand eines Produkts, ohne
es zu bonieren. Produkt scannen oder Taste drücken.</p>`),
K('4', 'Kassa eröffnen und abschließen', 1),
K('4.1', 'Kassa eröffnen', 2,
`<p>Zu Beginn des Tages geben Sie den Anfangsbestand ein - je Stückelung
die Anzahl der Scheine und Münzen.</p>
<p>Weicht Ihre Eingabe vom Betrag ab, mit dem am Vortag abgeschlossen wurde,
<b>warnt die Kassa und protokolliert die Abweichung</b>. Stimmen die Beträge
überein, läuft die Eröffnung ohne Rückfrage durch.</p>`, [
  { text: "Die Zählmaske: je Stückelung die Anzahl eintragen.", bild: "kassa-1-zaehlmaske" },
]),
K('4.2', 'Kassa abschließen', 2,
`<p>Am Ende des Tages zählen Sie die Lade und geben je Stückelung die
Anzahl ein. Die eingegebenen Beträge werden mit dem Soll verglichen und in
der Datenbank festgehalten.</p>
<p><b>Vor dem Abmelden muss die Kassa abgeschlossen sein</b> - sonst meldet
sie "Bitte, schließen Sie die Kassa vorher ab."</p>`),
K('4.3', 'Soll-Stand pruefen', 2,
`<p>Die Taste mit dem Fragezeichen vergleicht den eingegebenen mit dem
erwarteten Bestand und meldet eine Abweichung, ohne die Kassa
abzuschließen.</p>`),
K('4.4', 'Kassa Übergabe', 2,
`<p>Uebergibt die Kassa an einen anderen Benutzer. <b>Der übernehmende
Benutzer muss tatsächlich angemeldet sein</b> - ein nur angelegter Benutzer
wird abgelehnt.</p>`),
K('5', 'Die Symbole in der Kopfzeile', 1, null),
K('5.1', 'Bedeutung der sechs Symbole', 2,
`<p>Von links nach rechts:</p>
<ul>
<li><b>Kassenlade</b> - leuchtet, solange die Lade offen ist. Bei offener
Lade nimmt die Kassa keine Bonierung an.</li>
<li><b>Datenimport</b> - leuchtet während eines laufenden Datenimports.</li>
<li><b>Bon-Hinweis</b> - weist auf einen Vorschlag zum aktuellen Bon hin.</li>
<li><b>Rabatt</b> - zeigt an, dass ein Rabatt gewährt wurde.</li>
<li><b>Nachrichten</b> - <b>blinkt</b>, solange eine ungelesene Nachricht
vorliegt.</li>
<li><b>Kunde</b> - <b>blinkt</b>, sobald ein Kunde erkannt wurde.</li>
</ul>`, [
  { text: "Die sechs Symbole in der Kopfzeile.", bild: "kopfzeile-symbole" },
]),
K('6', 'Nachrichten', 1,
`<p>Ueber <b>Nachrichten</b> lesen und schreiben Sie Mitteilungen. Vier
Reiter trennen die Bereiche: <b>Allgemein</b>, <b>Filiale</b>,
<b>Persönlich</b> und <b>Gesendet</b>.</p>
<p>Eine Nachricht antippen öffnet sie und markiert sie als gelesen. Solange
Ungelesenes vorliegt, blinkt oben das Nachrichtensymbol.</p>`, [
  { text: "Das Nachrichtenbrett mit den vier Reitern.", bild: "nachrichten-1-brett" },
]),
K('7', 'Weitere Funktionen', 1),
K('7.1', 'Kassenladen-Funktionen', 2,
`<p><b>Lade öffnen</b>, <b>Kassa Entnahme</b>, <b>Kassa Einlage</b> und
<b>Wechselgeld</b>. Entnahmen und Einlagen werden mit Betrag festgehalten.</p>`),
K('7.2', 'Inventur und Retourware', 2,
`<p>Lagerstand ansehen, Ist-Bestand eingeben, Inventurlisten führen sowie
Retourware nach Lieferschein oder Bestand erfassen.</p>`),
K('7.3', 'Bankomat-Funktionen', 2,
`<p>Bankomat- und Kreditkarten-Abschluss (in dieser Kassa zu einer Taste
zusammengefasst), Wiederholung eines Kartenbelegs und Aktivierung des
Terminals.</p>`),
K('7.4', 'Benutzerfunktionen', 2,
`<p>Zeiterfassung (Pause eintragen), Benutzerwechsel und Abmelden.</p>`),
K('7.5', 'Sonderfunktionen', 2,
`<p>Bons speichern (Export der Finanzbelege auf einen USB-Stick),
Filialdaten ausdrucken, Kassa neu starten und abschalten.</p>`),
K('8', 'Die Tasten in der Kopfleiste', 1,
`<p>Ganz oben links stehen drei Tasten:</p>
<ul>
<li><b>Handbuch</b> - öffnet dieses Handbuch. Links das Verzeichnis, rechts
der Text; die Taste mit dem Kreuz schliesst es wieder.</li>
<li><b>Kalibrieren</b> - startet die Kalibrierung des Berührungsbildschirms.
Lässt sie sich nicht starten, meldet die Kassa den Grund.</li>
<li><b>Pflanze erkennen</b> - siehe Kapitel 9.</li>
</ul>`),
K('9', 'Pflanze erkennen', 1, null),
K('9.1', 'So verwenden Sie die Taste', 2,
`<p>Halten Sie die Ware vor die Kamera der Kassa und drücken Sie in der
Kopfleiste <b>Pflanze erkennen</b>. Die Kassa nimmt ein Bild auf, lässt es
einordnen und <b>schaltet die Produkttasten rechts auf die passende
Warengruppe</b> - liegt die Gruppe auf der zweiten Seite des Rasters,
blättert sie selbst dorthin. Den Artikel tippen Sie danach wie gewohnt
selbst an.</p>
<p>Während die Kassa wartet, läuft die Sanduhr. Die Erkennung
<b>bucht nichts</b> und ändert keinen Bon - sie wählt nur die Gruppe aus.
Eine falsche Erkennung kostet also nichts ausser einem Tastendruck auf den
richtigen Reiter.</p>`),
K('9.2', 'Wenn die Kassa nicht sicher ist', 2,
`<p>Erkennt die Kassa die Ware nicht sicher genug, <b>schaltet sie
absichtlich NICHT um</b> und meldet "Nicht sicher erkannt". Wählen Sie die
Warengruppe dann selbst - das ist schneller, als eine falsch aufgeschaltete
Gruppe wieder zu verlassen.</p>
<p>Geht etwas schief - keine Kamera, keine Verbindung - nennt die Meldung
den Grund. Die Taste bleibt nie stumm.</p>`),
K('9.3', 'Was eingestellt werden kann', 2,
`<p>Welche Warengruppen zur Auswahl stehen und wie streng die Kassa bei der
Sicherheit ist, wird <b>zentral am Server</b> eingestellt und gilt dann für
alle Kassen. An der Kassa selbst gibt es dafür keine Einstellung.</p>`),
];

// Kapitel ohne eigenen Text sind reine Überschriften.
export const HANDBUCH_SEITEN = HANDBUCH_KAPITEL.filter((k) => k.text).length;
